import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "login-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("img", {
    id: "bg1",
    class: "background-image1",
    alt: "Background Image"
  }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("img", {
    id: "bg2",
    class: "background-image2",
    alt: "Background Image"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("h1", null, "Login", -1)), _createVNode(_component_el_input, {
    class: "password-input",
    modelValue: $data.password,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.password = $event),
    placeholder: "输入认证码，若未设置留空即可~",
    type: "password",
    "show-password": "",
    onKeyup: _withKeys($options.login, ["enter", "native"])
  }, null, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_button, {
    class: "submit",
    type: "primary",
    onClick: $options.login
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("登录")])),
    _: 1
  }, 8, ["onClick"])])]);
}